import { render, staticRenderFns } from "./repeater.vue?vue&type=template&id=2bd823b7&scoped=true&"
import script from "./repeater.vue?vue&type=script&lang=js&"
export * from "./repeater.vue?vue&type=script&lang=js&"
import style0 from "./repeater.vue?vue&type=style&index=0&id=2bd823b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd823b7",
  null
  
)

export default component.exports